import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <g>
        <path
          fill={colourFill}
          d="M51.23 70H10.65a1.31 1.31 0 0 0 0 2.6h40.57a1.31 1.31 0 0 0 0-2.6ZM33.42 62.17c.94-1.67 2-3.23 3.11-4.86 6.83-10 16.18-23.74 16.18-33C52.71 11.48 43.08 1 31.24 1S9.76 11.47 9.76 24.35c0 9.23 9.36 22.95 16.19 33 1.11 1.62 2.17 3.18 3.1 4.84H4.41a.9.9 0 0 0-1.19.94c0 .65.53 1.18 1.19 1.66h57.41c.65-.48 1.18-1 1.18-1.66a1.18 1.18 0 0 0-1.18-1.19M12.13 24.35c0-11.57 8.57-21 19.11-21s19.1 9.41 19.1 21c0 8.49-9.11 21.86-15.76 31.63-1.2 1.75-2.34 3.43-3.34 5-1-1.51-2.14-3.19-3.33-4.94-6.66-9.77-15.78-23.14-15.78-31.64Z"
        />
        <path
          fill={colourFill}
          d="M42.56 22.49a11.33 11.33 0 1 0-11.32 11.34 11.34 11.34 0 0 0 11.32-11.34Zm-20.28 0a9 9 0 1 1 9 9 9 9 0 0 1-9-9Z"
        />
        <path
          fill={colourFill}
          d="M30.83 28.76a1.19 1.19 0 0 0 .84-.35c2.71-2.71 5.5-5.51 5.42-8.58A3.77 3.77 0 0 0 33 16.25a3.38 3.38 0 0 0-2.13 1 3.39 3.39 0 0 0-2.47-1 3.69 3.69 0 0 0-3.8 3.25c-.3 3.22 2.6 6.11 5.4 8.91a1.17 1.17 0 0 0 .83.34ZM27.35 20a1.36 1.36 0 0 1 1.35-1.35c.58 0 .92.12 1.48 1.24a1.18 1.18 0 0 0 2.12 0c.55-1.12.89-1.24 1.47-1.24A1.35 1.35 0 0 1 35.12 20c0 1.8-1.86 3.88-3.88 5.93-2.03-2.09-3.89-4.17-3.89-5.93Z"
        />
      </g>
    </svg>
  );
};

export default ServiceIcon;
